import { Image } from 'pcln-design-system'
import React, { useState } from 'react'
import styled from 'styled-components'

const LogoImage = styled(Image)`
  display: inline-block !important;
  margin: auto 0;
  width: 24px;
  max-height: 24px;
  vertical-align: middle;
  @media screen and (min-width: 600px) {
    width: 32px;
    max-height: 36px;
  }
`

const FallbackSVG = styled(Image)`
  display: inline-block;
  margin: auto 0;
  width: 24px;
  max-height: 24px;
  vertical-align: middle;

  @media screen and (min-width: 600px) {
    width: 32px;
    height: 100%;
    max-height: 36px;
  }
`

const AirlineImage = ({ airlineLogo, airlineName }) => {
  const [fallbackImage, setFallbackImage] = useState(false)

  const setErrorImage = () => {
    setFallbackImage(true)
  }

  const imageUrl = `https://s1.pclncdn.com/design-assets/fly/carrier-logos/${airlineLogo}?opto&auto=webp&height=32`

  const airlineImageSvg = 'https://s1.pclncdn.com/design-assets/fly-images/airline-image.svg?opto&auto=webp'

  return !fallbackImage ? (
    <LogoImage
      data-testid='airline-logo'
      alt={`${airlineName} logo`}
      src={imageUrl}
      onError={setErrorImage}
      loading='lazy'
    />
  ) : (
    <FallbackSVG src={airlineImageSvg} alt={`${airlineName} logo`} />
  )
}

export default AirlineImage
